"use client";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  getAdminLandingPage,
  getPublicLandingPage,
  publishAdminLandingPage,
  saveAdminLandingPage,
} from "@/lib/landing/api";
import { queryKeys } from "@/lib/query-keys";

export function usePublicLandingPage(slug = "home", enabled = true) {
  return useQuery({
    queryKey: queryKeys.publicLandingPage(slug),
    queryFn: () => getPublicLandingPage(slug),
    enabled,
    staleTime: 60_000,
    retry: 1,
  });
}

export function useAdminLandingPage(slug = "home", enabled = true) {
  return useQuery({
    queryKey: queryKeys.adminLandingPage(slug),
    queryFn: () => getAdminLandingPage(slug),
    enabled,
    retry: 1,
  });
}

export function useSaveAdminLandingPage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveAdminLandingPage,
    onSuccess: async (_, input) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: queryKeys.adminLandingPage(input.slug),
        }),
        queryClient.invalidateQueries({
          queryKey: queryKeys.publicLandingPage(input.slug),
        }),
      ]);
    },
  });
}

export function usePublishAdminLandingPage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: publishAdminLandingPage,
    onSuccess: async (_, input) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: queryKeys.adminLandingPage(input.slug),
        }),
        queryClient.invalidateQueries({
          queryKey: queryKeys.publicLandingPage(input.slug),
        }),
      ]);
    },
  });
}
